__turbopack_context__.v({
  "bannerImage": "modal-module-scss-module__CLqgjq__bannerImage",
  "closeButton": "modal-module-scss-module__CLqgjq__closeButton",
  "contents": "modal-module-scss-module__CLqgjq__contents",
  "header": "modal-module-scss-module__CLqgjq__header",
  "imageModal": "modal-module-scss-module__CLqgjq__imageModal",
  "large": "modal-module-scss-module__CLqgjq__large",
  "modal": "modal-module-scss-module__CLqgjq__modal",
  "noPadding": "modal-module-scss-module__CLqgjq__noPadding",
  "noScroll": "modal-module-scss-module__CLqgjq__noScroll",
  "small": "modal-module-scss-module__CLqgjq__small",
  "withFooter": "modal-module-scss-module__CLqgjq__withFooter",
  "wrapper": "modal-module-scss-module__CLqgjq__wrapper",
});
